export default __webpack_public_path__ + "static/media/FI.58304e5f.svg";